import createIconComponent from './utils/createIconComponent';
import React from 'react';
const SearchMagnifyPlus = createIconComponent({
  height: 32,
  width: 32,
  content: (
    <>
      <circle
        cx='14'
        cy='14'
        fill='none'
        id='XMLID_94_'
        r='9'
        stroke='#ffffff'
        stroke-linecap='round'
        stroke-linejoin='round'
        stroke-miterlimit='10'
        stroke-width='2'
      />
      <line
        fill='none'
        id='XMLID_93_'
        stroke='#ffffff'
        stroke-linecap='round'
        stroke-linejoin='round'
        stroke-miterlimit='10'
        stroke-width='2'
        x1='27'
        x2='20.366'
        y1='27'
        y2='20.366'
      />
      <line
        fill='none'
        id='XMLID_96_'
        stroke='#ffffff'
        stroke-linecap='round'
        stroke-linejoin='round'
        stroke-miterlimit='10'
        stroke-width='2'
        x1='14'
        x2='14'
        y1='10'
        y2='18'
      />
      <line
        fill='none'
        id='XMLID_97_'
        stroke='#ffffff'
        stroke-linecap='round'
        stroke-linejoin='round'
        stroke-miterlimit='10'
        stroke-width='2'
        x1='10'
        x2='18'
        y1='14'
        y2='14'
      />
    </>
  ),
});
SearchMagnifyPlus.displayName = 'SearchMagnifyPlus';
export default SearchMagnifyPlus;
